/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { WorkPackageStatuses } from '../../constants/storyStatusTypes';
import { updateWorkPackageStatus } from '../../actions/workPackageActions';
import { updateProductStatus } from '../../actions/productActions';

class DetailStatus extends React.Component {
  handleClick = event => {
    event.preventDefault();
    const { resultId, status, isNew, type } = this.props;
    if (isNew) {
      this.props.handleNewFieldChange({ state: event.target.name });
    } else if (type === 'product') {
      this.props.updateProductStatus(resultId, event.target.name);
    } else {
      this.props.updateWorkPackageStatus(resultId, event.target.name, status);
    }
  };

  render() {
    const { status } = this.props;
    const disabled = !this.props.allowEdit;

    return (
      <div className="row">
        <div className="col-sm-3">
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.NOT_READY}
              className={`status-btn ${
                status === WorkPackageStatuses.NOT_READY
                  ? 'not-ready-active'
                  : 'not-ready-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
              FUNNEL
            </button>
          </div>
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.GETTING_READY}
              className={`status-btn ${
                status === WorkPackageStatuses.GETTING_READY
                  ? 'getting-ready-active'
                  : 'getting-ready-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
              ANALYZING
            </button>
          </div>
        </div>
        <div className="col-sm-3">
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.READY}
              className={`status-btn ${
                status === WorkPackageStatuses.READY
                  ? 'ready-active'
                  : 'ready-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
              BACKLOG
            </button>
          </div>
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.IN_PROGRESS}
              className={`status-btn ${
                status === WorkPackageStatuses.IN_PROGRESS
                  ? 'progress-active'
                  : 'progress-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
              IMPLEMENTING
            </button>
          </div>
        </div>
        <div className="col-sm-3">
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.COMPLETED}
              className={`status-btn ${
                status === WorkPackageStatuses.COMPLETED
                  ? 'complete-active'
                  : 'complete-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
              VALIDATING
            </button>
          </div>
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.ACCEPTED}
              className={`status-btn ${
                status === WorkPackageStatuses.ACCEPTED
                  ? 'accepted-active'
                  : 'accepted-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
              DEPLOYING
            </button>
          </div>
        </div>
        <div className="col-sm-3">
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.SHIPPABLE}
              className={`status-btn ${
                status === WorkPackageStatuses.SHIPPABLE
                  ? 'shippable-active'
                  : 'shippable-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
              RELEASING
            </button>
          </div>
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.LIVE}
              className={`status-btn ${
                status === WorkPackageStatuses.LIVE
                  ? 'live-active'
                  : 'live-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
              LIVE
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DetailStatus.propTypes = {
  status: PropTypes.string,
  resultId: PropTypes.number,
  allowEdit: PropTypes.bool,
  isNew: PropTypes.bool,
  type: PropTypes.string
};

DetailStatus.defaultProps = {
  type: 'workPackage'
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateWorkPackageStatus,
      updateProductStatus
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(DetailStatus);
